"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsOnlyProducer = void 0;
var files_auth_provider_1 = require("../providers/files-auth-provider");
/**
 * Returns true if the auth'd user is ONLY a producer, meaning they aren't also an AM, Enginner or Operations.
 */
function useIsOnlyProducer() {
    var user = (0, files_auth_provider_1.useAuthProvider)().userDetails;
    if (!user) {
        return false;
    }
    var rolesSet = new Set(user.roles);
    return (rolesSet.has('Producer') &&
        !rolesSet.has('AccountManager') &&
        !rolesSet.has('Engineer') &&
        !rolesSet.has('Operations'));
}
exports.useIsOnlyProducer = useIsOnlyProducer;
